module.exports = __webpack_public_path__ + "img/logo-bs2.9393cd67.svg";